import { Tag } from "antd";
import { Actions } from "../components/buttons/Actions";
import { GenericSwitch } from "../components/elements/Switch";
import { actionsColumn, activeColumn } from "../constants/objects";
import { sAddSection, SORT } from "../constants/strings";
import { useAppContext } from "../context/useAppContext";
import { FeedForm, feedTypes } from "../forms/FeedForm";
import { findInArray } from "../utils/helpers";
import { useFirebase } from "./firebase/useFirebase";
import { CreateDrawer } from "../components/drawer/DrawerComponent";

export const useFeed = () => {
  const { contextData } = useAppContext();
  const { deleteData } = useFirebase();

  const tableData = (data) => [
    ...data.map((item) => {
      // for banner images
      const deleteUrls = item?.banners?.map(({ url }) => url);

      const row = {
        title: (
          <div>
            {item.title}
            <p className="font11 thin lightColor">{item.subtitle}</p>
          </div>
        ),
        sort: item.sort,
        type: <Tag>{findInArray(feedTypes, item.type, "id")?.name}</Tag>,
        active: (
          <GenericSwitch end checked={item.active} docRef={item.docRef} />
        ),
        actions: (
          <Actions
            actions={[
              {
                action: "Delete",
                click: () => deleteData(item?.docRef, deleteUrls),
                confirm: true,
              },
            ]}
          />
        ),
        onclick: () =>
          contextData.showGlobalDrawer({
            component: <FeedForm data={item} />,
            title: "Update Section",
          }),
      };
      return row;
    }),
  ];

  const tableColumns = () => [
    { id: "title", align: "left" },
    { id: SORT },
    { id: "type" },
    activeColumn,
    actionsColumn,
  ];

  return {
    tableColumns,
    tableData,
    header: () => {
      return <CreateDrawer title={sAddSection} form={<FeedForm />} />;
    },
  };
};
